import { aroundSchool } from "../../data/resourcesData";
import { Link } from "react-router-dom";
import ResourceHero from "./ResourceHero";
import "../../css/Videos.css";

export default function Videos() {
  return (
    <>
      <ResourceHero
        title=" Videos"
        subtitle="Stay updated with the latest educational insights, school news, learning tips, and inspiring stories from our community."
        image="/images/Education_Funds1.png"
      />
      <section className="resources-section" id="videos">
        <h2 className="resources-heading">
          More around Sahara Public Secondary School
        </h2>
        <div className="resources-card-grid">
          {aroundSchool.map((v, i) => (
            <a className="resources-video-card" href={v.href} key={i}>
              <div className="resources-video-thumb">
                <img src={v.thumbnail} alt={v.title} />
                <span className="resources-play-btn">▶</span>
              </div>
              <div className="resources-meta">
                <span>{v.date}</span>
              </div>
              <h3>{v.title}</h3>
              <p>{v.excerpt}</p>
            </a>
          ))}
        </div>
      </section>
      {}

      <section className="resources-extra-section">
        <div className="resources-heading-center">
          <span className="section-badge">Video Library</span>

          <h2>Explore Videos By Category</h2>

          <p>
            Discover classroom activities, sports events, cultural celebrations,
            educational workshops and campus life through our video collection.
          </p>
        </div>

        <div className="video-category-grid">
          <div className="video-category-card">
            <h3>Campus Life</h3>
            <p>
              Experience everyday student life, classrooms and learning
              environment.
            </p>
          </div>

          <div className="video-category-card">
            <h3>Sports</h3>
            <p>
              Watch exciting sports competitions, tournaments and annual
              athletic events.
            </p>
          </div>

          <div className="video-category-card">
            <h3>Cultural Events</h3>
            <p>Explore annual functions, festivals and student performances.</p>
          </div>

          <div className="video-category-card">
            <h3>Achievements</h3>
            <p>Celebrate academic excellence and student success stories.</p>
          </div>
        </div>
      </section>
      {}

      <section className="resources-highlight">
        <div className="highlight-content">
          <div>
            <span className="section-badge">School Experience</span>

            <h2>See Sahara Public School In Action</h2>

            <p>
              Our videos provide parents and students with a closer look at
              school life, modern classrooms, extracurricular activities, events
              and student achievements before visiting the campus.
            </p>

            <ul>
              <li>✔ Real classroom experience</li>

              <li>✔ Student activities & events</li>

              <li>✔ Modern learning environment</li>

              <li>✔ Sports & cultural programmes</li>
            </ul>

            <Link to="/contact" className="resources-primary-btn">
              Book A Campus Visit
            </Link>
          </div>

          <div className="highlight-image">
            <img src="./images/k.jpeg" alt="School" />
          </div>
        </div>
      </section>
    </>
  );
}
